<script lang="ts">
  import PubSub from "pubsub-js";
  import { fetchApiProducts } from "./lib/Product";
  import { init, _ } from "svelte-i18n";
  import ProductListHeaderMasonry from "./Components/ListHeaderMasonry.svelte";
  import ProductListMasonrySsr from "./Components/ProductListMasonrySsr.svelte";
  import ProductListMasonry from "./Components/ProductListMasonry.svelte";
  import ProductListHeader from "./Components/ListHeader.svelte";
  import ProductList from "./Components/ProductList.svelte";
  import { settings } from "./stores/settings.ts";
  import { debounce } from "lodash";

  export let selectedCategories =
    typeof a3_filter_ctgs !== "undefined" ? a3_filter_ctgs : [];
  export let selectedTags = [];
  export let priceRange = [];
  export let query_vars;
  export let description =
    typeof a3_current_term_desc !== "undefined" ? a3_current_term_desc : "";
  export let ssr = false;
  export let total_matches = 0;
  export let lang = typeof a3_lang !== "undefined" ? a3_lang : "hr";
  export let env = typeof a3_env !== "undefined" ? a3_env : "dev";
  export let elastic_index =
    typeof a3_elastic_index !== "undefined" ? a3_elastic_index : -1;
  export let products = [];
  let selectedTopCategories = [];
  let archive_sort;
  let loading = false;

  $settings.showElements.productList.gridListToggle = elastic_index != 1;

  $: archive_sort =
    selectedTopCategories.length > 1 ||
    typeof a3_current_term_id === "undefined";

  $: console.log(products.length, "products length");

  let firstLoad = true;
  let queryChanged = 0;
  let scrollY = 0;

  console.log("category start !!!!!!!!!!!!!!!!!!");
  console.log(elastic_index, $settings.showElements.productList.gridListToggle);

  const maybeResetPage = () => {
    if (!firstLoad) {
      query_vars.paged = 0;
      changePage(null, 1);
      console.log(query_vars);
    }
  };
  const maybeResetOrder = () => {
    if (!firstLoad) {
      query_vars.orderby = "menu_order";
    }
  };

  const categoryFilterChanged = (msg, data) => {
    console.log(msg, data);
    maybeResetPage();
    maybeResetOrder();

    //if (!is_same(selectedCategories, data.selectedCategories)) {
    selectedCategories = [...data.selectedCategories];
    // }
    selectedTopCategories = data.selectedTopCategories;

    console.log({ selectedTopCategories });
    archive_sort = selectedTopCategories.length > 1;

    if (
      query_vars.taxonomy === "product_cat" &&
      selectedCategories.length === 0
    ) {
      if (typeof a3_current_term_children !== "undefined") {
        selectedCategories = selectedCategories.concat(
          a3_current_term_children,
        );
      } else if (typeof a3_current_term_id !== "undefined") {
        selectedCategories.push(a3_current_term_id);
      }
    }

    console.log({ queryChanged, selectedCategories });

    queryChanged = 1;

    console.log({ queryChanged, selectedCategories });
  };

  const tagFilterChanged = (msg, data) => {
    console.log(msg, data);
    maybeResetPage();
    maybeResetOrder();

    // if (!is_same(selectedTags, data.selectedTags)) {
    selectedTags = [...data.selectedTags];
    // }

    if (
      query_vars.taxonomy === "product_tag" &&
      // selectedTags.length === 0 &&
      typeof a3_current_term_id !== "undefined"
    ) {
      selectedTags.push(a3_current_term_id);
    }

    queryChanged = 2;
  };

  const priceFilterChanged = (msg, data) => {
    console.log(msg);
    maybeResetPage();

    priceRange = data.priceRange;
  };

  const filterAndFetchProducts = async ({
    selectedCategories: filterCategories,
    selectedTags: filterTags,
    priceRange: filterPrice,
    query_vars: filterVars,
    lang: filterLang,
    env,
    elastic_index,
    archive_sort,
  }) => {
    console.log({ elastic_index });

    if (queryChanged > 0) {
      filterPrice = priceRange = [];
    }

    loading = true;
    // Only clear products if this is a new search/filter, not pagination
    if (queryChanged > 0 && queryChanged !== 3) {
      products = [];
    }

    const result = await fetchApiProducts({
      term_id:
        typeof a3_current_term_id !== "undefined" ? a3_current_term_id : null,
      filterCategories,
      filterTags,
      filterPrice,
      filterVars,
      filterLang,
      env,
      elastic_index,
      archive_sort,
    });

    console.log({ queryChanged });

    if ((!ssr && firstLoad) || queryChanged > 0) {
      PubSub.publish("PRODUCTS_FILTERED", { result });
    }

    products = result?.products ?? [];
    products = products.map((p) => ({
      ...p,
      permalink: "/" + p.permalink.replace(/^(?:\/\/|[^/]+)*\//, ""),
    }));
    total_matches = result?.total ?? 0;
    loading = false;

    console.log(total_matches, products.length);

    firstLoad = false;
    queryChanged = 0; // important for reactivity

    if (typeof window !== "undefined") {
      const url_parts = window.location.href.split("?");
      let queryString = url_parts.length > 1 ? url_parts[1] : "";
      let queryArgs = queryString.split("&");

      queryArgs = queryArgs.filter((qarg) => qarg);

      if (queryArgs.find((qarg) => qarg.startsWith("filterCtg"))) {
        queryArgs.forEach((qarg, index, arr) => {
          if (qarg.startsWith("filterCtg=")) {
            arr[index] = "filterCtg=" + selectedCategories.join(",");
          }
        });
      } else {
        queryArgs.push("filterCtg=" + selectedCategories.join(","));
      }

      if (queryArgs.find((qarg) => qarg.startsWith("filterTag"))) {
        queryArgs.forEach((qarg, index, arr) => {
          if (qarg.startsWith("filterTag=")) {
            arr[index] = "filterTag=" + selectedTags.join(",");
          }
        });
      } else {
        queryArgs.push("filterTag=" + selectedTags.join(","));
      }

      queryString = queryArgs.join("&");

      window.history.replaceState(
        {},
        "",
        `${url_parts[0]}${queryString ? "?" + queryString : ""}`,
      );
    }
  };

  const debFilterAndFetchProducts = debounce(filterAndFetchProducts, 100);

  const changePage = async (ev, page) => {
    console.log("changePage");
    query_vars.paged = page;

    var element = document.getElementsByClassName("a3_product_list");

    if (element && element.length > 0) {
      console.log("scroll to #a3_product_list");
      // var yPos = element.getBoundingClientRect().top + window.scrollY;
      // scrollY = yPos;
      element[0].scrollIntoView();
    }

    if (typeof window !== "undefined") {
      const url_parts = window.location.href.split("?");
      let url;
      let queryString = url_parts.length > 1 ? url_parts[1] : "";
      if (url_parts[0].match(/page\/\d+\/?$/g)?.length > 0) {
        url = url_parts[0].replace(
          /page\/\d+\/?$/,
          `page/${page}/${queryString ? `?${queryString}` : ""}`,
        );
      } else {
        url = `${url_parts[0]}page/${page}/${
          queryString ? "?" + queryString : ""
        }`;
      }
      window.history.replaceState({}, "", url);
    }

    queryChanged = 3;
  };

  const changeSortOrder = (ev) => {
    console.log("changeSortOrder");

    if (typeof window !== "undefined") {
      const url_parts = window.location.href.split("?");
      let url;
      let queryString = url_parts.length > 1 ? url_parts[1] : "";
      let queryArgs = queryString.split("&");
      queryArgs = queryArgs.filter((qarg) => qarg != "");
      const orderby = queryArgs.find((qarg) => qarg.startsWith("orderby="));
      if (orderby) {
        queryArgs.forEach(function (qarg, index, theArray) {
          if (qarg.startsWith("orderby=")) {
            theArray[index] = `orderby=${query_vars.orderby}`;
          }
        });
      } else {
        if (queryArgs.length > 0) {
          queryArgs.push(`orderby=${query_vars.orderby}`);
        } else {
          queryArgs = [`orderby=${query_vars.orderby}`];
        }
      }
      url = `${url_parts[0]}${
        queryArgs.length > 0 ? "?" + queryArgs.join("&") : ""
      }`;
      window.history.replaceState({}, "", url);
    }

    maybeResetPage();
  };

  const initLang = (lang) => {
    if (!lang) {
      const htmlTag = document.getElementsByTagName("html")[0];
      lang = htmlTag?.getAttribute("lang") ?? "en-US";
    }

    init({
      fallbackLocale: "en-US",
      initialLocale: lang,
    });
  };

  function loadProducts(queryChanged) {
    console.log("loadProducts", queryChanged);

    // products = [];

    if (queryChanged < 1) return;

    debFilterAndFetchProducts({
      selectedCategories,
      selectedTags,
      priceRange,
      query_vars,
      lang,
      env,
      elastic_index,
      archive_sort,
    });
  }

  initLang(lang);

  $: loadProducts(queryChanged);

  loadProducts(1);

  if (!ssr) {
    PubSub.subscribe("CATEGORY_FILTER_CHANGED", categoryFilterChanged);
    PubSub.subscribe("TAG_FILTER_CHANGED", tagFilterChanged);
    // PubSub.subscribe("PRICE_FILTER_CHANGED", priceFilterChanged);

    if (query_vars.taxonomy === "product_cat") {
      if (selectedCategories.length === 0) {
        if (typeof a3_current_term_children !== "undefined") {
          selectedCategories = selectedCategories.concat(
            a3_current_term_children,
          );
        } else if (typeof a3_current_term_id !== "undefined") {
          selectedCategories.push(a3_current_term_id);
        }
      }
    } else if (query_vars.taxonomy === "product_tag") {
      if (
        selectedTags.length === 0 &&
        typeof a3_current_term_id !== "undefined"
      ) {
        selectedTags.push(a3_current_term_id);
      }
    }
  }

  function getProductListType(elastic_index, ssr) {
    if (elastic_index == 2) {
      if (ssr) {
        return ProductListMasonrySsr;
      } else {
        return ProductListMasonry;
      }
    } else {
      return ProductList;
    }
  }

  function getProductListHeaderType(elastic_index) {
    if (elastic_index == 2) {
      return ProductListHeaderMasonry;
    } else {
      return ProductListHeader;
    }
  }
</script>

<svelte:window bind:scrollY />

<!--<main id="main" class="site-main" role="main">-->
<svelte:component
  this={getProductListHeaderType(elastic_index)}
  {query_vars}
  {total_matches}
  {products}
  {description}
  {changeSortOrder}
/>

<div class="a3_product_list">
  {#if loading && products.length === 0}
    <div class="loading-indicator">Loading products...</div>
  {:else}
    <svelte:component
      this={getProductListType(elastic_index, ssr)}
      {products}
    />
  {/if}
</div>

<nav class="woocommerce-pagination">
  <ul class="page-numbers">
    {#each Array(Math.ceil(total_matches / query_vars.posts_per_page)) as _, page}
      {#if page + 1 === query_vars.paged || (query_vars.paged === 0 && page === query_vars.paged)}
        <li>
          <span
            aria-current="page"
            class="page-numbers current"
            on:click|preventDefault={(ev) => changePage(ev, page + 1)}
            >{page + 1}</span
          >
        </li>
      {:else}
        <li>
          <a
            href="#{page + 1}"
            class="page-numbers"
            on:click|preventDefault={(ev) => changePage(ev, page + 1)}
            >{page + 1}</a
          >
        </li>
      {/if}
    {/each}
  </ul>
</nav>

<!-- </main> -->

<!-- #main -->
<style>
  #main {
    max-width: 100%;
  }

  .a3_product_list {
    clear: both;
  }

  .loading-indicator {
    text-align: center;
    padding: 2rem;
    font-size: 1.1rem;
    color: #666;
  }
</style>
